import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Container, Button } from '@components';
import { breakpoints } from '@config';
import { useMatchMedia } from '@utils';
import {
  Picture,
  Wrapper,
  Head,
  StyledTitle,
  StyledText,
  CircleWrap,
  Circle,
  ButtonWrapper
} from './styles';
import ui from './ui.webp';
import uiRetina from './ui@2x.webp';
import uiMobile from './ui-mobile.webp';
import uiMobileRetina from './ui-mobile@2x.webp';

export interface TestProps {
  handleClick?: () => void;
}

const Test: React.FC<TestProps> = ({ handleClick }) => {
  const [ runAnimation, setRunAnimation ] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const match = useMatchMedia(breakpoints.pc);
  
  const handleScroll = useCallback(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const animationBreakPoint = match ? 50 : 300;
      
      if (rect.top < animationBreakPoint) {
        setRunAnimation(true);
      } else {
        setRunAnimation(false);
      }
    }
  }, [ match ]);
  
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, [ handleScroll ]);
  
  const picture = (
    <Picture>
      <source
        media={`(max-width: ${breakpoints.pc})`}
        srcSet={`${uiMobile} 1x, ${uiMobileRetina} 2x`}
      />
      <img src={ui} srcSet={`${uiRetina} 2x`} alt="" />
    </Picture>
  );
  
  return (
    <Wrapper id={'test'} ref={ref}>
      <Container align={'top'} maxWidth={1049}>
        { !match && picture }
        <Head>
          <StyledTitle as={'h2'} level={'2'}>
            Готовы<br />
            к интеграции
          </StyledTitle>
          {
            match
            && <StyledText level={'1'} colorName={'textLittleTransparency'}>
              Аватары — это будущее нашего общения в интернете. Интегрируйте первые части Web3 уже сейчас
            </StyledText>
          }
          <ButtonWrapper>
            <Button
              icon={'arrow-right'}
              fullWidth
              onClick={handleClick}
            >
              Конструктор аватаров
            </Button>
          </ButtonWrapper>
        </Head>
        { match && picture }
      </Container>
      <CircleWrap maxCircle={match ? 1785 : 593} runAnimation={runAnimation}>
        <Circle circle={match ? 1785 : 593} transparency={0.2} />
        <Circle circle={match ? 1339 : 444} transparency={0.1} />
      </CircleWrap>
    </Wrapper>
  );
};

export { Test };
